module.exports = __webpack_public_path__ + "img/2.19a4b376.png";